import React from 'react'
import { lit } from 'src/utils'

export interface HeroProps {
    /**
     * The class name to be used to hook GA event tracking
     */
    analyticsClassName?: string

    /**
     * The class name to be used for styling purposes
     */
    className?: string

    /**
     * Text and media can be on either the left or right side for tablet and larger view ports
     */
    mediaPlacementTabletAndUp?: 'left' | 'right'

    /**
     * Allows user to pass in the image to be displayed in the component
     */
    media: React.ReactNode

    /**
     * The heading text to be displayed on the hero
     */
    heading: React.ReactNode

    /**
     * The call to action element used in the hero
     */
    cta: React.ReactNode

    /**
     *  A string | React node to be rendered below the header
     */
    children: React.ReactNode
}

export function Hero({
    analyticsClassName = 'js_Hero',
    mediaPlacementTabletAndUp = 'right',
    heading,
    children,
    cta,
    media,
    className,
}: Readonly<HeroProps>) {
    const flexDirectionClassName =
        mediaPlacementTabletAndUp === 'left'
            ? 'flex flex-col md:flex-row'
            : 'flex flex-col md:flex-row-reverse'

    const paddingClassName =
        mediaPlacementTabletAndUp === 'left' ? 'md:pr-14' : 'md:pl-14'

    return (
        <section
            className={lit`${analyticsClassName} ${flexDirectionClassName} ${className}`}
        >
            <div className={lit`md:basis-7/12 ${paddingClassName}`}>
                {media}
            </div>
            <div className="flex flex-col p-5 text-left md:basis-5/12 md:justify-center md:p-0">
                <h1 className="text-[1.75rem] font-bold leading-8 md:text-5xl">
                    {heading}
                </h1>
                <div className="pb-2 pt-5 text-lg md:text-xl">{children}</div>
                <div className="mt-6">{cta}</div>
            </div>
        </section>
    )
}
